import {
  percent,
  px,
  url,
  twoValueSize,
} from '@packages/systems/core/utils/WebflowCssSubset';

export const noPseudoYouTubeStyle = {
  width: percent(100),
  position: 'relative',
  paddingBottom: px(0),
  paddingLeft: px(0),
  paddingRight: px(0),
  backgroundImage: url(
    'https://d3e54v103j8qbb.cloudfront.net/static/youtube-placeholder.2b05e7d68d.svg'
  ),
  backgroundSize: 'cover',
  backgroundPosition: twoValueSize(percent(50), percent(50)),
} as const;

export const emptyYouTubeStyle = {
  minHeight: px(75),
  paddingBottom: percent(56.25),
} as const;
